module.exports = __webpack_public_path__ + "media/content-creator/travel-3-87771ec6.png";